<template>
  <div
    class="notification__user"
    :class="{'notification__user_clickable' : hasNotificationClickHandler}"
    @click="handleNotificationClick">
    <div class="notification__header">
      <p class="notification__title">
        <span class="bold">
          {{ lastItem.createdAtFormatted.day }}
        </span>
        <span>
          {{ lastItem.createdAtFormatted.time }}
        </span>
      </p>
      <span
        class="shape-cross"
        @click.stop="hideNotification" />
    </div>
    <div class="notification__body">
      <div class="notification__message">
        {{ lastItem.description }}
      </div>
      <button
        v-if="lastItem.button"
        class="button button-main"
        @click.stop="handleButtonClick">
        {{ lastItem.button.text }}
      </button>
    </div>
  </div>
</template>

<script>
const AUTO_HIDE_NOTIFICATION_DELAY = 60000;

export default {
  name: 'NotificationsItemUser',

  props: {
    notification: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      hideTimeout: null,
    };
  },

  computed: {
    lastItem() {
      return this.notification.items[this.notification.items.length - 1];
    },

    hasNotificationClickHandler() {
      return typeof this.lastItem?.notificationClickHandler === 'function';
    },
  },

  mounted() {
    if (document.visibilityState === 'visible') {
      this.setHideTimeout();
    } else {
      document.addEventListener('visibilitychange', this.setHideTimeout, { once: true });
    }
  },

  beforeDestroy() {
    clearTimeout(this.hideTimeout);
    document.removeEventListener('visibilitychange', this.setHideTimeout, { once: true });
  },

  methods: {
    setHideTimeout() {
      this.hideTimeout = setTimeout(() => {
        this.hideNotification();
      }, AUTO_HIDE_NOTIFICATION_DELAY);
    },

    hideNotification() {
      this.$emit('hide', this.notification.id);
    },

    handleButtonClick(event) {
      this.lastItem.button.handler(event);
      this.hideNotification();
    },

    handleNotificationClick(event) {
      if (this.hasNotificationClickHandler) {
        this.lastItem.notificationClickHandler(event);
        this.hideNotification();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .notification__user {
    font-size: $text-13px;
    font-weight: 300;
    color: $color--basic-light-gray;

    .bold {
      font-weight: 500;
      color: $color--basic-white;
    }

    .button {
      padding: 6px 15px;
      font-size: $text-11px;
    }
  }

  .notification__user_clickable {
    cursor: pointer;
  }

  .notification__message {
    margin: 12px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .shape-cross {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 45px;
    top: 15px;
  }
</style>
